import { EventEmitter, Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class AdditionalServiceService {
  public editAdditionalCostItem: EventEmitter<any> = new EventEmitter();

}
